import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { AuthenticationState } from './types'

export const getters: GetterTree<AuthenticationState, RootState> = {}

export default getters
